// This file was generated by lezer-generator. You probably shouldn't edit it.
export const
  BackgroundModifier = 1,
  Modifier = 2,
  StackModifier = 3,
  Keyword = 4,
  NotText = 5,
  BackgroundKeyword = 6,
  Stack = 7
